import React from 'react';
import ReactImageIcon, { ReactImageIconProps } from '@jswork/react-image-icon';

interface Props extends ReactImageIconProps {
  hoverable?: boolean;
}

const ImageIcon = (props: Props): JSX.Element => {
  const { value, hoverable, ...otherProps } = props;
  const filename = value as string;
  const [name, ratio] = filename.split('@');
  const normal = require(`common/assets/images/v2icons/${name}@${ratio}.png`);
  const _value = hoverable
    ? {
        normal,
        hover: require(`common/assets/images/v2icons/${name}_hover@${ratio}.png`),
      }
    : normal;

  // @ts-ignore
  return <ReactImageIcon size={30} value={_value}{...otherProps} />;
};

export default ImageIcon;
